module.exports = __webpack_public_path__ + "assets/base44.45781f25.svg";